import React from "react";

// components
import MarketingMessageModal from "./MarketingMessageModal";

// hooks
import { useAuth } from "frontend/hooks/useAuth";
import useFeatureFlag from "frontend/hooks/useFeatureFlag";
import { DISABLE_MARKETING_MESSAGE_MODAL } from "frontend/data/featureFlags";

// component
const MarketingMessageModalWrapper = () => {
    const hasFeatureFlag = useFeatureFlag(DISABLE_MARKETING_MESSAGE_MODAL);
    const { marketingMessageModal } = useAuth();
    const { userMessage } = marketingMessageModal;
    if (hasFeatureFlag || !userMessage) return null;
    return <MarketingMessageModal userMessage={userMessage} />;
};

export default MarketingMessageModalWrapper;
